import Loader from "elements/Loader";
import Colors from "modules/Colors";
import { CSSProperties } from "react";

const OrganizationTabLoading = () => {
    return (
        <div
            className="organizationTabLoadingComponent"
            style={sty.organizationTabLoadingComponent}
        >
            <Loader />
            <div>Loading...</div>
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    organizationTabLoadingComponent: {
        height: 200,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 4,
        backgroundColor: Colors.greyLight,
        marginTop: 24,
        borderRadius: 8,
    }
}

export default OrganizationTabLoading;